import {AutoSuggestQueryBuilder} from "./builders/autosuggest/autosuggest-query-builder";
import {SearchQueryBuilder} from "./builders/search/search-query-builder";
import {SearchObjectsModel, SearchArguments} from "../../../types/Search";

export const getSearchQuery = (args: SearchArguments, searchObjectsModel: SearchObjectsModel, includeAggregations: boolean) => {
  if (includeAggregations) {
    return new SearchQueryBuilder(args, searchObjectsModel).build();
  }
  return new SearchQueryBuilder(args, searchObjectsModel).withoutAggregations().build();
};

export const getSuggestQuery = (searchTerms: string, searchObjectsModel: SearchObjectsModel) => {
  return new AutoSuggestQueryBuilder(searchTerms, searchObjectsModel).build();
};
